module.exports = __webpack_public_path__ + "static/media/CTLI_17-111w.630def85.webp";